/**
 * Prefix of the "Referential" navigation group (Contacts, and soon Accounts, IDL templates…): the
 * base data of the platform that is not part of the Onboardings or Transfers flows. The router and
 * the paths below both read it from here, so renaming it is a one-line change.
 */
export const REFERENTIAL_BASE = '/referential'

export const CONTACTS_BASE = `${REFERENTIAL_BASE}/contacts`

export const ACCOUNTS_BASE = `${REFERENTIAL_BASE}/accounts`

export const REGISTRATIONS_BASE = `${REFERENTIAL_BASE}/registrations`

export const IDL_TEMPLATES_BASE = `${REFERENTIAL_BASE}/idl-templates`

/** In-app paths of the referential pages (Onboardings group), shared by links and redirects. */
export const referentialPaths = {
  accounts: {
    list: ACCOUNTS_BASE,
    detail: (uuid: string) => `${ACCOUNTS_BASE}/${uuid}`,
  },
  contacts: {
    list: CONTACTS_BASE,
    detail: (uuid: string) => `${CONTACTS_BASE}/${uuid}`,
  },
  idlTemplates: {
    list: IDL_TEMPLATES_BASE,
    detail: (uuid: string) => `${IDL_TEMPLATES_BASE}/${uuid}`,
  },
  masterFunds: {
    list: '/onboardings/master-funds',
    detail: (uuid: string) => `/onboardings/master-funds/${uuid}`,
  },
  pocketGroups: {
    list: '/onboardings/pocket-groups',
    detail: (uuid: string) => `/onboardings/pocket-groups/${uuid}`,
  },
  pockets: {
    list: '/onboardings/pockets',
    detail: (uuid: string) => `/onboardings/pockets/${uuid}`,
  },
  registrations: {
    list: REGISTRATIONS_BASE,
    detail: (uuid: string) => `${REGISTRATIONS_BASE}/${uuid}`,
  },
}

/**
 * Same pages exposed from the Transfers menu. Pocket groups have no Transfers page: their links
 * stay in Onboardings.
 */
export const transfersReferentialPaths: typeof referentialPaths = {
  ...referentialPaths,
  masterFunds: {
    list: '/transfers/master-funds',
    detail: (uuid: string) => `/transfers/master-funds/${uuid}`,
  },
  pockets: {
    list: '/transfers/pockets',
    detail: (uuid: string) => `/transfers/pockets/${uuid}`,
  },
}

/** Master funds and Pockets pages mounted under Transfers (not `/transfers/:uuid`). */
const TRANSFERS_REFERENTIAL_PATHNAME = /^\/transfers\/(master-funds|pockets)(\/|$)/

export const getReferentialPaths = (pathname: string): typeof referentialPaths =>
  TRANSFERS_REFERENTIAL_PATHNAME.test(pathname) ? transfersReferentialPaths : referentialPaths
